import eclipseItems from '@utils/eclipseItems';
import { useDSTMetaInfoStore } from '@stores/dst/dstStore';
import { emptyObject } from '@constants/empty';
import { ENGLISH_LANGUAGE_PREFERENCE } from '@cont/Quiz/constants';

const useLanguages = () => {
  const { quizInfo } = useDSTMetaInfoStore();
  const { availableLanguage = [ENGLISH_LANGUAGE_PREFERENCE] } =
    quizInfo ?? emptyObject;

  const languages = [];

  availableLanguage.forEach((language) => {
    if (language.code !== -1) {
      languages.push(language.displayName);
    }
  });

  return {
    languages,
    formatedLanguages: languages.length ? `${eclipseItems(languages)}` : ''
  };
};

export default useLanguages;
